__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/49b603747d64b617650f5e141bdbf5bec93e2b5b979be19727ed23af/";